import { PaginationFilterField, PaginationParamFilter } from '@shell/types/store/pagination.types';
import { NodeSnapshot } from '@shell/utils/lattice-node-overview';

export interface NodeInventorySelection { role: string; zone: string }
const ROLE_PREFIX = 'node-role.kubernetes.io/';
const ZONE = 'topology.kubernetes.io/zone';
const LEGACY_ZONE = 'failure-domain.beta.kubernetes.io/zone';
const FILTER_MARKER = 'latticeNodeInventory';

export function nodeMatchesInventory(node: NodeSnapshot, selection: NodeInventorySelection): boolean {
  const labels = node.metadata?.labels || {};
  const roles = Object.keys(labels).filter((key) => key.startsWith(ROLE_PREFIX) && key.length > ROLE_PREFIX.length).map((key) => key.slice(ROLE_PREFIX.length));
  const role = selection.role;
  const matchesRole = !role || (role === 'Role unspecified' ? !roles.length : role === 'Control plane' ? roles.some((value) => ['master', 'control-plane'].includes(value)) : role === 'Worker' ? roles.some((value) => ['worker', 'Worker'].includes(value)) : roles.includes(role));

  return matchesRole && (!selection.zone || (labels[ZONE] || labels[LEGACY_ZONE]) === selection.zone);
}

/** Mutate the native pagination argument: ResourceFetch consumes that object, not the callback return value. */
export function applyNodeInventoryApiFilter(pagination: any, selection: NodeInventorySelection): any {
  const filters = (pagination.filters || []).filter((filter: any) => !filter[FILTER_MARKER]);
  const add = (fields: PaginationFilterField[]) => {
    const group = new PaginationParamFilter({ fields });

    (group as any)[FILTER_MARKER] = true;
    filters.push(group);
  };
  const presence = (key: string) => new PaginationFilterField({ field: `metadata.labels[${ key }]`, exists: true });
  const equal = (key: string, value: string) => new PaginationFilterField({ field: `metadata.labels[${ key }]`, value });

  if (selection.role && selection.role !== 'Role unspecified') {
    add(selection.role === 'Control plane' ? [presence(`${ ROLE_PREFIX }master`), presence(`${ ROLE_PREFIX }control-plane`)] : selection.role === 'Worker' ? [presence(`${ ROLE_PREFIX }worker`), presence(`${ ROLE_PREFIX }Worker`)] : [presence(`${ ROLE_PREFIX }${ selection.role }`)]);
  }
  if (selection.zone) {
    // (modern matches OR legacy matches) AND (modern matches OR modern absent/empty).
    // This keeps the same modern-label precedence as the local inventory.
    add([equal(ZONE, selection.zone), equal(LEGACY_ZONE, selection.zone)]);
    add([equal(ZONE, selection.zone), equal(ZONE, ''), new PaginationFilterField({ value: `!metadata.labels[${ ZONE }]` })]);
  }
  pagination.filters = filters;

  return pagination;
}
